module.exports = __webpack_public_path__ + "static/media/detail_0051_f.2e168d6c.jpg";